import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const hydropowerApi = createApi({
    reducerPath: "core/hydropower",
    baseQuery: axiosBaseQuery,
    tagTypes: ["hydropowerList"],
    endpoints: (builder) => ({
        hydropowerFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['hydropowerList'],
            query: (query = '') => ({
                url: "/core/hydropower" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        hydropowerCreate: builder.mutation({
            invalidatesTags: ['hydropowerList'],
            query: (data) => ({
                url: `/core/hydropower`,
                method: "POST",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        }),
        hydropowerUpdate: builder.mutation({
            invalidatesTags: ['hydropowerList'],
            query: (data) => ({
                url: `/core/hydropower/${data.get('id')}`,
                method: "PUT",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                } 
            })
        }),

        hydropowerDelete: builder.mutation({
            invalidatesTags: ['hydropowerList'],
            query: (id) => ({ url: "/core/hydropower/" + id, method: "DELETE" })
        }),
    })
})

export const { useHydropowerFindAllQuery, useHydropowerCreateMutation, useHydropowerUpdateMutation, useHydropowerDeleteMutation } = hydropowerApi;
export { hydropowerApi };
